import {config} from '@config';

import {getPreloadUrls} from '@helpers/dom';
import {sleep} from '@helpers/utils';
import {Pjax, PjaxSignalType} from '@lib/Pjax';
import {Time} from '@lib/Time';
import {createApplicationState} from '@services/ApplicationState';
import {Preloader} from '@services/Preloader';
import {IApplicationState, IComponentGenerator} from '@services/types';

type Props = {
  preloader: Preloader;
  generator: IComponentGenerator;
};

export class Navigation {
  static singleton: Navigation;
  pjax: Pjax;
  generator: IComponentGenerator;
  preloader: Preloader;
  appState: IApplicationState;

  static create(props: Props) {
    if (Navigation.singleton) {
      return Navigation.singleton;
    }
    return (Navigation.singleton = new Navigation(props));
  }

  constructor({preloader, generator}: Props) {
    this.preloader = preloader;
    this.generator = generator;
    this.appState = createApplicationState();
    this.pjax = Pjax.create();
    this.pjax.onChange.connect(this.onChange.bind(this));
  }

  private onChange({event, type}: {event: Event; type: PjaxSignalType}) {
    if (type === 'fetch') {
      this._fetch();
    } else if (type === 'ready') {
      this._loaded(event);
    }
  }

  private _fetch() {
    Time.create().start('pageIndicator');
    this.generator.willUnmount();
    this.appState.updatePageIndicatorStatus('show');
  }

  async _loaded(e: Event) {
    this.generator.unmount();

    const {request: {responseURL = ''} = {}} =
      (e as any) /*FIXME: 型がない*/ || {};
    this.appState.updateCurrentPageUrl(responseURL);

    const urls = getPreloadUrls();
    await this.preloader.load(urls);

    this.generator.refresh();

    await sleep(
      config.pageIndicatorShowAnimationDuration -
        Time.create().getDuration('pageIndicator'),
    );
    this.appState.updatePageIndicatorStatus('hide');
  }

  getContainer() {
    return this.pjax.getContainer();
  }

  start(containerSelector: string) {
    this.pjax.start({
      fetchDelay: config.pageIndicatorShowAnimationDuration, // indicatorが表示されてからdomの入れ替え
      selector: containerSelector,
    });
  }

  navigate(url: string) {
    this.pjax.loadUrl(url);
  }
}
